export const cheerfulfriendly = {
  name: 'Cheerful & Friendly',
  color: [0.6980392156862745, 0.8588235294117647, 0.8352941176470589, 1],
  bg: [0.16862745098039217, 0.3803921568627451, 0.42745098039215684, 1],
  grid1: [1, 1, 1, 1],
  grid2: [0.9803921568627451, 0.5529411764705883, 0.3843137254901961, 1],
}
